import { isEmptyString } from '@vy/string';
import type { CommitmentVsUsageReportItem } from '@vy/types';
import { caseInsensitiveIncludes } from '@vy/utils';

export function applyCommitmentVsUsageSearch(
  reportItems: CommitmentVsUsageReportItem[],
  searchText: string | null | undefined,
): CommitmentVsUsageReportItem[] {
  const normalized = searchText?.trim();
  if (isEmptyString(normalized)) {
    return reportItems;
  }

  return reportItems.filter((item) => {
    const matchesCustomerName = caseInsensitiveIncludes(item.customer.name, normalized);
    const matchesContractName = caseInsensitiveIncludes(item.contract.name, normalized);
    const matchesProductName = caseInsensitiveIncludes(item.product.name, normalized);
    const matchesVariantName = caseInsensitiveIncludes(item.product.variantName, normalized);

    return matchesCustomerName || matchesContractName || matchesProductName || matchesVariantName;
  });
}
